import { render, staticRenderFns } from "./video2.vue?vue&type=template&id=3e66baaa"
import script from "./video2.vue?vue&type=script&lang=js"
export * from "./video2.vue?vue&type=script&lang=js"
import style0 from "./video2.vue?vue&type=style&index=0&id=3e66baaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports